export default __webpack_public_path__ + "static/media/single-tap.060fadb0.svg";